import {appMonitor} from "../../util/analytics";
import {rumConfig} from "../../AuthenticatedRoute/Amplify";

export const analytics = appMonitor({
        appId: rumConfig.RUM_APP_ID,
        guestRoleArn: rumConfig.RUM_ROLE_ARN,
        identityPoolId: rumConfig.RUM_IDPOOL_ID
});